import type {FC} from "react";
import {Flex, Text} from "@chakra-ui/react";
import {useCreditsStore} from "../../store/useCreditsStore.ts";
import SmartIcon from "../SmartIcon.tsx";
import {isReadOnly} from "./subscriptionPresentation.ts";

const MEMBER_NOTICE =
  "Only workspace admins can change billing. Contact your workspace admin to upgrade, cancel or request a refund.";

// Leads both views for a member, so the reason every billing control is missing is read first.
export const MemberNotice: FC = () => {
  const balance = useCreditsStore((state) => state.balance);
  if (balance?.schemaVersion !== 2 || !isReadOnly(balance)) return null;

  return (
    <Flex
      mb={4}
      px={4}
      py={3}
      gap={2}
      align="flex-start"
      rounded="xl"
      borderWidth="1px"
      borderColor="n.300"
      data-testid="subscription-member-notice"
    >
      <SmartIcon className="mt-0.5 shrink-0 fill-n-400" name="info-circle" size={18}/>
      <Text className="text-pretty" fontSize="sm" color="n.500">{MEMBER_NOTICE}</Text>
    </Flex>
  );
};
